export default {
      id: "map-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#map-usage",
      toString: function () {
        return this.url;
      }
    }